module.exports = __webpack_public_path__ + "img/04.2e3d7354.jpg";